module.exports = __webpack_public_path__ + "static/media/lucy.cb7a8e34.png";